import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import { env } from '@core/config/env';
import { karofiTheme } from '@base/ui/theme';
import { UrlParamsValidator } from '@features/router/url-params-validator';

const queryClient = new QueryClient();

async function enableMocking() {
  if (env.enableMockApi && env.env === 'development') {
    const { startMockAPI } = await import('./mocks/browser');
    return startMockAPI();
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider theme={karofiTheme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <UrlParamsValidator />
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>
  );
});